import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import Tooltip from '../components/Tooltip'
import Checkbox from '../components/Checkbox'
import GlyphDots from '../icons/GlyphDots'

const Transaction = ({
  index, transactionId, amount, priceForToken, transactionTime, dealType, onSelect, focused, selected
}) => {
  const dotsWrapper = useRef()

  var className = 'flex items-center sans-serif';
  const styles = { height: 36, background: '#ffffff', overflow: 'hidden' }
  /*const styles = index % 2 === 0
    ? { height: 74, background: '#ffffff', overflow: 'hidden' }
    : { height: 74, background: '#f7f7f7', overflow: 'hidden' }*/

  const PURCHASE = 1;
  const SELL = 2;
  var dealTypeStr = "None";

  if (parseInt(dealType) === PURCHASE)
    dealTypeStr = "Purchase";
  else if (parseInt(dealType) === SELL)
    dealTypeStr = "Sell";

  const timeVariance = 10800;
  const newStr = Date.now()/1000-timeVariance <= transactionTime && Date.now()/1000+timeVariance > transactionTime
    ? "New" : "";

  const transactionTimeStr = new Date(transactionTime * 1000).toLocaleString("ja");

  return (
    <div className={className} style={styles}>
      <div className='flex-grow-1 w-5 tc f5 pl2 pr1 red truncate'>{newStr}</div>
      <div className='flex-grow-1 w-20 tc f5 gray truncate'>{transactionId}</div>
      <div className='flex-grow-1 w-20 tc f5 gray truncate'>{transactionTimeStr}</div>
      <div className='flex-grow-1 w-20 tc f5 gray truncate'>{dealTypeStr}</div>
      <div className='flex-grow-1 w-15 tc f5 gray truncate'>{amount}</div>
      <div className='flex-grow-1 w-20 tc f5 gray truncate'>{priceForToken}</div>
    </div>
  )
}

export default Transaction;
